export class AppController {

    constructor($log, $state, ProductDataService) {
        'ngInject';

        $log.debug('AppController::constructor');

        this.productDataService = ProductDataService;

        this.productDataLoaded = false;

        this.productDataService.load().then(() => {
            this.productDataLoaded = true;

            $state.go('start');
        });

    }


}



// WEBPACK FOOTER //
// ./src/js/app.controller.js